var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Billing Exchange Rate' : 'Add Billing Exchange Rate',
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "width": "500px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-position": "right",
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "From Currency",
      "prop": "fromCurrency"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Select Currency"
    },
    model: {
      value: _vm.dataForm.fromCurrency,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "fromCurrency", $$v);
      },
      expression: "dataForm.fromCurrency"
    }
  }, _vm._l(_vm.currencyList, function (item) {
    return _c('el-option', {
      key: "modal-from-".concat(item.currency),
      attrs: {
        "label": item.currency,
        "value": item.currency
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "To Currency",
      "prop": "toCurrency"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Select Currency"
    },
    model: {
      value: _vm.dataForm.toCurrency,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "toCurrency", $$v);
      },
      expression: "dataForm.toCurrency"
    }
  }, _vm._l(_vm.currencyList, function (item) {
    return _c('el-option', {
      key: "modal-to-".concat(item.currency),
      attrs: {
        "label": item.currency,
        "value": item.currency
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Exchange Rate",
      "prop": "exchangeRate"
    }
  }, [_c('el-input-number', {
    staticClass: "tal wdb100",
    attrs: {
      "precision": 4,
      "min": 0,
      "step": 0.0001,
      "controls-position": "right"
    },
    model: {
      value: _vm.dataForm.exchangeRate,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "exchangeRate", $$v);
      },
      expression: "dataForm.exchangeRate"
    }
  })], 1)], 1), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }